import {
  type AnyRuleType,
  StyleRule,
  MediaRule,
} from '@packages/systems/style/style-sheets';
import type {ValueType} from '@packages/systems/style/properties';
import type {CSSWriter} from './types';

export class CSSStringWriter implements CSSWriter<string> {
  isCommitted = false;
  padding = '';
  output = '';
  rules = [];

  throwIfCommitted(reason: string) {
    if (this.isCommitted) {
      throw new Error(
        `CSSStringWriter can't ${reason} after it was committed.`
      );
    }
  }

  addRule(rule: AnyRuleType) {
    this.throwIfCommitted('add a rule');
    // @ts-expect-error - TS2345 - Argument of type 'AnyRuleType' is not assignable to parameter of type 'never'.
    this.rules.push(rule);
  }

  addDeclaration(property: string, value: ValueType) {
    this.throwIfCommitted('add declaration');
    if (this.output) this.output += '\n';
    this.output += `${this.padding}${property}: ${value};`;
  }

  writeStyleRule(styleRule: StyleRule) {
    const selector = styleRule.selector.toString();
    if (!selector) return;
    if (this.output) this.output += '\n';
    this.output += `${this.padding}${selector} {`;
    const {padding} = this;
    this.padding += '  ';
    styleRule.block.toCSS(this);
    this.padding = padding;
    this.output += `\n${this.padding}}`;
  }

  writeMediaRule(mediaRule: MediaRule) {
    let queries = '';
    for (const query of mediaRule.queries) {
      if (queries) queries += ', ';
      queries += query.toCSS();
    }

    if (this.output) this.output += '\n';
    this.output += `@media ${queries} {`;
    const {padding} = this;
    this.padding += '  ';
    for (const styleRule of mediaRule.rules) {
      this.writeStyleRule(styleRule);
    }
    this.padding = padding;
    this.output += `\n${this.padding}}`;
  }

  commit(): string {
    if (this.isCommitted) {
      return this.output;
    }
    for (const rule of this.rules) {
      // @ts-expect-error - TS2358 - The left-hand side of an 'instanceof' expression must be of type 'any', an object type or a type parameter.
      if (rule instanceof StyleRule) {
        this.writeStyleRule(rule);
        // @ts-expect-error - TS2358 - The left-hand side of an 'instanceof' expression must be of type 'any', an object type or a type parameter.
      } else if (rule instanceof MediaRule) {
        this.writeMediaRule(rule);
      }
    }
    this.isCommitted = true;
    return this.output;
  }
}
